import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataDuplicateRoutesDtoModelBase } from './PlanningActionMetadataDuplicateRoutesDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataDuplicateRoutesDtoModel */
export interface PlanningActionMetadataDuplicateRoutesDtoModelType extends Instance<typeof PlanningActionMetadataDuplicateRoutesDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataDuplicateRoutesDtoModel */
export {
  selectFromPlanningActionMetadataDuplicateRoutesDto,
  planningActionMetadataDuplicateRoutesDtoModelPrimitives,
  PlanningActionMetadataDuplicateRoutesDtoModelSelector,
} from './PlanningActionMetadataDuplicateRoutesDtoModel.base';

/**
 * PlanningActionMetadataDuplicateRoutesDtoModel
 */
export const PlanningActionMetadataDuplicateRoutesDtoModel = PlanningActionMetadataDuplicateRoutesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
